import SvgIcon from '@mui/material/SvgIcon';

export default function AddIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </SvgIcon>
  );
}
